export var ReportType;
(function (ReportType) {
    ReportType["LINE"] = "line";
    ReportType["PIE"] = "pie";
    ReportType["BAR"] = "bar";
    ReportType["STACKED_BAR"] = "stackedbar";
    ReportType["TABLE"] = "table";
    ReportType["STATISTIC"] = "statistic";
    ReportType["FORECAST"] = "forecast";
    ReportType["AREA"] = "area";
    ReportType["CARBON_ACTIONS"] = "carbonactions";
    ReportType["SUNBURST"] = "sunburst";
    ReportType["SANKEY"] = "sankey";
    ReportType["FACET_STACKED_BAR"] = "facetStackedBar";
    ReportType["TREE_MAP"] = "treemap";
    ReportType["TARGETS_MIXED"] = "targetsMixed";
    ReportType["MAP"] = "map";
})(ReportType || (ReportType = {}));
export var ReportsName;
(function (ReportsName) {
    ReportsName["TotalOrganizationFootprintQuery"] = "total-organizational-footprint-query";
    ReportsName["TotalOrganizationFootprintQueryGroupByBU"] = "total-organizational-footprint-query-by-bu";
    ReportsName["TotalOrganizationFootprintQueryGroupByLocation"] = "total-organizational-footprint-query-by-location";
})(ReportsName || (ReportsName = {}));
//# sourceMappingURL=Report.js.map